export default {
  hrOptions: {
    1: 'Yes',
    2: 'No',
    3: 'I\'m the HR',
  },

  wfhOptions: {
    1: 'Required',
    2: 'Allowed',
    3: 'Only if sick / travelled to high risk countries',
    4: 'Not allowed',
  },

  travelOptions: {
    1: 'Allowed',
    2: 'Discouraged',
    3: 'Restricted',
  },

  visitorOptions: {
    1: 'Allowed',
    2: 'Discouraged',
    3: 'Restricted',
  },

  eventsOptions: {
    1: 'Allowed',
    2: 'Discouraged',
    3: 'Restricted',
  },

  companyReadiness: [
    {
      labelText: 'Do you allow employees to work from home?',
      id: 'allowEmployeesWfh',
      formKey: 'allow_work_from_home',
      dropdownKey: 'wfhOptions',
    },
    {
      labelText: 'Do you allow employees to travel?',
      id: 'allowEmployeesTravel',
      formKey: 'allow_travel',
      dropdownKey: 'travelOptions',
    },
    {
      labelText: 'Do you allow visitors to your office?',
      id: 'allowVisitorsToOffice',
      formKey: 'allow_visitors',
      dropdownKey: 'visitorOptions',
    },
    {
      labelText: 'Do you still host/attend events?',
      id: 'hostEvents',
      formKey: 'allow_events',
      dropdownKey: 'eventsOptions',
    },
  ],

  companyRemoteReadiness: [
    {
      labelText: 'Do you use video conference tools like Zoom, Hangouts, Slack, etc.?',
      id: 'hasVideoConference',
      formKey: 'uses_video_conference_tools',
    },
    {
      labelText: 'Do you use a project management tool like Trello?',
      id: 'hasProjectManagementTools',
      formKey: 'uses_project_management_tools',
    },
    {
      labelText: 'Do you have clear SOPs?',
      id: 'haveSop',
      formKey: 'has_clear_sops',
    },
    {
      labelText: 'Do you use a shared Cloud storage/collaboration tool like Google Drive, Dropbox, etc.?',
      id: 'shareCloudStorage',
      formKey: 'set_communications_protocol',
    },
    {
      labelText: 'Do you have a tech team in your company?',
      id: 'haveTechTeam',
      formKey: 'has_tech_team',
    },
    {
      forTech: true,
      labelText: 'Do your tech team schedule regular virtual meetings?',
      id: 'scheduleRegularCall',
      formKey: 'schedule_regular_scrums',
    },
    {
      forTech: true,
      labelText: 'Does your tech team use Git?',
      id: 'usesGit',
      formKey: 'uses_git',
    },
  ],
};
